// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e5fba45e","239":"192b2c57","453":"62cc214f","732":"8c7e7bae"}[chunkId] + ".chunk.js";
};